import React from 'react'
import './section2.css'
import enroll from './images/logo-cyber.png';
import { Link } from 'react-router-dom';

const Section2 = () => {
  return (
    <div className='section2'>
      <div className='lab-div'>
<div className='lab-div-left'>
    <img src={enroll} alt=''/>
</div>
<div className='lab-div-mid'>
    <p>Enroll For Lab</p>
</div>
<div className='lab-div-right'>
 <Link to="/">
<button>Register Now</button>
</Link>
</div>
      </div>
    </div>
  )
}

export default Section2


